<template>
  <div class="loginMain">
    <div class="box-shadow login-box" style="z-index: 1">
      <div style="padding: 0px 15px"> 
        <el-tabs v-model="curIndex"  @tab-click="callback">
          <el-tab-pane label="员工登录" name="1" style="margin:0 20px;">
            <img style="width:200px;margin:auto;display: block;" src="@/assets/img/member.png" />
            <el-button class="form-submit login-button" @click="gotoUids" round >员工登录</el-button>
          </el-tab-pane>
          <el-tab-pane label="账号登录" name="2">
         <el-form
          ref="loginForm"
          label-position="top"
          :rules="rules"
          :model="formLogin"
          size="mini"
          style="margin:20px;"
        >
          <el-form-item prop="user">
            <div class="login-row">
              <div class="label yhm"></div>
              <div class="input">
                <input placeholder="请输入用户名" v-model="formLogin.user" />
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="pwd">
            <div class="login-row">
              <div class="label mm"></div>
              <div class="input">
                <input
                  placeholder="请输入密码"
                  v-model="formLogin.pwd"
                  type="password"
                />
              </div>
            </div>
          </el-form-item>  
          <el-button class="form-submit login-button" @click="submit" round style="margin-top: 50px;"
            >登录</el-button>
            <div
              style="
                font-size: 10px;
                color: rgb(80, 180, 254);
                text-align: right;
                padding: 10px 0;
              "
            > 
          </div>
          </el-form>
        </el-tab-pane>
        </el-tabs>
        
        <input  type="hidden" name="captchaId" value="7555f49b1a884df79adfb7b36e117206">
        <div id="captcha"></div>
      </div>
    </div>

    <!--div style="display: flex">
      <van-button class="form-submit login-button" @click="login" round>登录</van-button>
    </div-->
    <div class="login-bottom" style="z-index: -1"> 
      <div flex-shrink="0" flex class="d2-theme-footer">
        <span class="d2-mr-20">@2022 上海罗氏制药有限公司工会委员会</span>
        <span
          ><a href="https://beian.miit.gov.cn/" style="color: #3f73eb;">沪ICP备2021032853号-1</a></span
        >
      </div>
    </div>

    <el-dialog
      :visible.sync="loginContentShow"
      width="40%"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <div class="dlgTitle">知情同意书</div>
      <!-- <div class="jzts">1.员工个人敏感数据数据存储的地点。</div>
      <div class="jzts">2.可能接触到员工个人敏感数据的人员（或者是第三方)</div>
      <div class="jzts">3.员工个人敏感数据存储时间:5年(是否能做到?)</div>
      <div class="jzts">4.员工个人敏感数据用途:福利发放l重疾及意外保险等</div>
      <div class="jzts">
        5.员工第一次入职罗氏的时间的用途:解决二次入职不能自行申请入会
      </div> -->
      <div>罗氏工会（下称“我们”）非常尊重用户个人信息的保护，在您使用平台提供的服务时，我们将按照本隐私权政策收集、使用及共享您的个人信息。本隐私权政策包含了我们收集、存储、使用、共享和保护您的个人信息的条款，建议您完整地阅读本隐私权政策，以帮助您了解维护自己隐私权的方式。如您对本隐私权政策有任何疑问，您可以通过平台公布的联系方式与我们联系。如果您不同意本隐私权政策任何内容，您应立即停止使用平台服务。如您继续使用平台的任一服务，即意味着您已同意我们按照本隐私权政策来合法收集、使用、储存和分享您的相关信息。</div>
      <div>一、适用范围</div>
      <div>本隐私权政策适用于平台提供的所有服务，您访问平台网站及/或登陆相关平台移动门户使用平台提供的服务，均适用本隐私权政策。</div>
      
      <div>二、我们如何收集信息</div>
      <div>我们收集信息是为了向您提供优质、个性化的服务，我们收集信息的方式如下：</div>
      <div>1.您向我们提供的信息。 当您注册账户及您在使用平台时提供的相关服务时填写及或提交的信息，包括您的姓名、性别、出生年月日、身份证号码、护照姓名、护照号码、电话号码、电子邮箱、地址、邮编、入职日期及相关附加信息。</div>
      <div>2.在您使用服务过程中收集的信息。 为了提供并优化您需要的服务，我们会收集您使用服务的相关信息，这类信息包括：</div>
      <div>在您使用平台服务，或访问平台网页时，系统自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器信息、访问日期和时间、语言、软硬件特征信息及您浏览的网页记录等数据；如您访问移动网页使用平台服务，或使用其关联小程序，可能会读取与您位置和移动设备相关的信息，包括但不限于设备型号、操作系统、设备识别码、分辨率、电信运营商等。 除上述信息外，我们还可能为了提供服务及改进服务质量、服务个性化等合理需要而收集您的其他信息，包括您与我们的客户服务团队联系时您提供的相关信息，您参与问卷调查活动时向我们提供的问卷答复信息，以及您与的关联方、合作伙伴之间互动时我们收集的相关信息。与此同时，为提高您使用平台服务时的安全性，预防钓鱼网站欺诈和木马病毒，我们可能会通过了解或记录一些您的网络使用习惯、您常用的软件信息等手段来判断您账户的风险，并可能会记录一些我们认为有风险的URL。</div>
      
      
      <div>三、我们如何使用信息</div>
      <div>收集您的信息是为了向您提供优质、个性化服务的目的，为了实现该目的，我们会把您的信息用于下列用途：</div>
      <div>1.向您提供您使用的福利发放/重疾及意外保险辅助申请等各项服务，并维护、改进这些服务。</div>
      <div>2.准确定位二次入职人员，以解决二次入职人员不能自行入会等功能实现的需要。</div>
      <div>3.我们可能使用您的个人信息以预防、发现、调查欺诈、危害安全、非法或违反与我们或其关联方协议、政策或规则的行为，以保护您、其他我们用户，或我们或其关联方的合法权益。</div>
      <div>4.经您许可的其他用途。</div>
      
      <div>四、我们如何共享信息</div>
      <div>我们对您的信息承担保密义务，不会为满足第三方的营销目的而向其出售或出租您的任何信息，我们会在下列情况下才将您的信息与第三方共享：</div>
      <div>1.事先获得您的同意或授权。</div>
      <div>2.根据法律法规的规定或行政或司法机构的要求。</div>
      <div>3.向关联方分享您的个人信息。</div>
      <div>4.向可信赖的合作伙伴提供您的个人信息，让他们根据我们的指示并遵循我们的隐私权政策以及其他任何相应的保密和安全措施来为我们处理这些信息。</div>
      <div>5.如您出现违反中国有关法律、法规或者相关协议或相关规则的情况，需要向第三方披露。</div>
      <div>6.为维护及其关联方或用户的合法权益。</div>
      
      <div>五、Cookie 和网络 Beacon 的使用</div>
      <div>为使您获得更轻松的访问体验，您访问平台相关网站或使用平台提供的服务时，我们可能会通过Cookie，Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”），以向您提供个性化的用户体验和服务。</div>
      <div>请您理解，我们的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝的Cookie，但这一举动可能会影响您安全访问平台相关网站和使用平台提供的服务。</div>
      <div>网页上常会包含一些电子图象（称为"单像素" GIF 文件或 "网络 beacon"），使用网络beacon可以帮助网站计算浏览网页的用户或访问某些cookie，我们会通过网络beacon收集您浏览网页活动的信息，例如您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定等。</div>
      
      <div>六、信息存储</div>
      <div>收集的有关您的信息和资料将保存在及（或）其关联公司的服务器上，保存时限自您入会起5年，到期后将重新销毁后进行再次采集，这些信息和资料可能传送至您所在国家、地区或收集信息和资料所在地并在该地被访问、存储和展示。</div>
      
      <div>七、您的个人信息保护</div>
      <div>为保障您的信息安全，我们努力采取各种合理的安全措施来保护您的信息，以防信息的泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于与他们签署保密协议，根据岗位的不同采取不同的权限控制，监控他们的操作情况等措施。</div>
      <div>您的账户均有安全保护功能，请妥善保管您的账户及密码信息。将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但也请您理解，由于技术的限制以及可能存在的各种恶意行为，在互联网上不能保证百分之百的安全。</div>
      <div>请您妥善保护自己的个人信息，仅在必要的情形下向他人提供，并且对此行为产生的后果承担责任。在您使用我们的服务时所提供、上传、或发布的内容和信息（比如照片），可能会泄露您的敏感个人信息，请您慎重考虑是否在使用使披露。如您发现自己的个人信息泄密，尤其是你的账户及密码发生泄露，请您立即联络客服，以便采取相应措施。</div>
      
      <div class="jzts" style="text-align: right">
        <el-checkbox v-model="isZx">我已知晓</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="isZx == false"
          @click="toLogin"
          class="jzbtn"
          type="primary"
          round
          >确认</el-button
        >
        <el-button class="jzcancen jzbtn" @click="handleClose" round
          >取消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */

import config from "./config/default";
import { mapActions, mapState } from "vuex";
import * as sysService from "@/api/sys/sys";
export default {
  data() {
    return {
      // 表单
      formLogin: {
        user: "",
        pwd: "",
      },
      // 校验
      rules: {
        user: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      isZx: false,
      captchaIns:"",
      curIndex:"1",
      flag:false
    };
  },
  computed: {
    ...mapState("d2admin/account", ["loginContentShow"]),
  },
  created() {
    // if (
    //   this.$route.query &&
    //   this.$route.query.loginType &&
    //   this.$route.query.loginType == "1"
    // ) {
    // } else {
    //   this.gotoUids();
    // }
  },
  mounted() {
    var _this= this;
    initNECaptcha({
        element: '#captcha',
        captchaId: '7555f49b1a884df79adfb7b36e117206',
        mode: 'popup',
        width: '390px',
        onClose: function () {
            // 弹出关闭结束后将会触发该函数
            _this.submit();
        }
    }, function (instance) {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        _this.captchaIns = instance
    }, function (err) {
        // 初始化失败后触发该函数，err对象描述当前错误信息
    });
  },
  beforeDestroy() {},
  methods: {
    callback(key){
      console.log(key);
      // this.curIndex = key;
    },
    ...mapActions("d2admin/account", [
      "login",
      "surelogin",
      "gotoUids",
      "cancellogin",
    ]),
    /**
     * @description 接收选择一个用户快速登录的事件
     * @param {Object} user 用户信息
     */
    handleUserBtnClick(user) {
      this.formLogin.user = user.user;
      this.formLogin.pwd = user.pwd;
      this.submit();
    },
    /**
     * @description 提交表单
     */
    // 提交登录信息
    submit() {
      
      if (this.captchaIns && !this.flag) {
          this.captchaIns.popUp();
          this.flag = true;
          return false;
      }
      this.flag = false;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // 登录
          // 注意 这里的演示没有传验证码
          // 具体需要传递的数据请自行修改代码
          this.login({
            vm: this,
            user: this.formLogin.user,
            pwd: this.formLogin.pwd
          });
        } else {
          // 登录表单校验失败
          this.$message.error("表单校验失败");
        }
      });
    },
    toLogin() {
      this.surelogin({
        vm: this,
      });
    },
    handleClose(done) {
      let that = this;
      this.$confirm("是否取消登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.cancellogin({
            vm: that,
          });
        })
        .catch(() => {});
    },
    resetDb() {
      sysService.resetDb();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
html #app,
body #app {
  height: 100%;
} 
.jump-button{
  width:100%;
  height:36px;
  margin-left: 0;
  color:#3f73eb;
}
.login-bottom{
  width: 450px;
  margin-left: calc(50% - 225px);
  font-size: 13px;
  margin-bottom: 5px;
}
::v-deep .el-tabs__nav{
  font-weight: bold;
  font-size: 20px;
  line-height: 60px;
}
::v-deep .el-tabs__item{
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  font-family: 黑体;
} 
::v-deep .el-tabs__active-bar{
  width:100px;
}
.login-button
{
  font-size: 16px;
}
</style>
